export type { i18nFn } from '../../../../../../../types';

export enum ERiskLevel {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export enum EScoreTab {
  SCORE_RESULT = 'score_result',
  GENERAL_INFO = 'general_info',
}

export enum EAlertSeverity {
  DANGER = 'danger',
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
}

export enum EAppointmentStatus {
  HEALTHY = 'healthy',
  ATTENTION = 'attention',
}

export enum EPersonType {
  PJ = 'PJ',
  PF = 'PF',
}

export interface IMetricCard {
  icon: string;
  label: string;
  value: string;
  helperText?: string;
  tooltipKey?: string;
}

export interface ICreditLimit {
  total: number;
  available: number;
  used: number;
  usagePercent: number;
}

export type AppointmentCategoryKey = 'debts' | 'civilActions' | 'protests';

export interface IAppointmentCategory {
  key: AppointmentCategoryKey;
  icon: string;
  title: string;
  subtitle?: string;
  status: EAppointmentStatus;
  statusLabel: string;
  emptyMessage?: string;
  latestDateLabel: string;
  latestDate: string;
  totalCountLabel: string;
  totalCount: number;
  totalValueLabel: string;
  totalValue: number;
}

export interface IAppointmentDetailField {
  label: string;
  value: string;
}

export interface IAppointmentDetailRecord {
  fields: IAppointmentDetailField[];
}

export interface IAppointmentDetailSection {
  id: string;
  title: string;
  subtitle?: string;
  emptyMessage?: string;
  itemsPerPage?: number;
  records: IAppointmentDetailRecord[];
}

export interface IScoreChartPoint {
  date: string;
  value: number;
}

export interface ICreditAlert {
  severity: EAlertSeverity;
  message: string;
}

export interface IConsultationSelection {
  consultationId: string;
  latest: boolean;
}

export interface IRiskAnalysis {
  personType: string;
  available: boolean;
  riskLevel: ERiskLevel;
  riskLabel: string;
  riskDescription: string;
  descriptionPrefix?: string;
}

export interface ICreditScoreData {
  scoreId: string;
  personType: EPersonType;
  companyName: string;
  document: string;
  score: number;
  scoreMax: number;
  scoreUnavailable: boolean;
  lastUpdatedAt: string;
  riskLevel: ERiskLevel;
  probabilityRiskLevel: ERiskLevel;
  probabilityAvailable: boolean;
  riskLabel: string;
  probabilityPercent?: string;
  probabilityLabel: string;
  probabilityDescription: string;
  riskAnalysis: IRiskAnalysis;
  creditLimit: ICreditLimit;
  metricCards: IMetricCard[];
  scoreChartPoints: IScoreChartPoint[];
  appointments: IAppointmentCategory[];
  appointmentDetailsSections: IAppointmentDetailSection[];
  alerts: ICreditAlert[];
  isHistoricalView?: boolean;
  hasOperationalIndicators?: boolean;
}
